var _g, _path, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBRightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1305,
    height: 772,
    viewBox: "0 0 1305 772",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_738_5236_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.50324e-08 0.147216 -0.245429 4.17368e-08 676 381)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 665.688,
    height: 175.204,
    fill: "url(#paint0_diamond_738_5236)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 665.688,
    height: 175.204,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_738_5236)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 665.688,
    height: 175.204,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_738_5236)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 665.688,
    height: 175.204,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_738_5236)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M676 381L718 405.25V453.75L676 478L634 453.75V405.25L676 381Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.39607843756675720,\"g\":0.35294118523597717,\"b\":0.85490196943283081,\"a\":1.0},\"position\":0.25961539149284363},{\"color\":{\"r\":1.0,\"g\":0.89019608497619629,\"b\":0.63921570777893066,\"a\":0.80000001192092896},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.39607843756675720,\"g\":0.35294118523597717,\"b\":0.85490196943283081,\"a\":1.0},\"position\":0.25961539149284363},{\"color\":{\"r\":1.0,\"g\":0.89019608497619629,\"b\":0.63921570777893066,\"a\":0.80000001192092896},\"position\":1.0}],\"transform\":{\"m00\":5.0064823881257325e-05,\"m01\":-490.85745239257812,\"m02\":921.42864990234375,\"m10\":294.432128906250,\"m11\":8.3473612903617322e-05,\"m12\":233.78390502929688},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_diamond_738_5236_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.51943e-08 0.14816 -0.247016 4.20046e-08 676.451 381.203)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 666.995,
    height: 175.987,
    fill: "url(#paint1_diamond_738_5236)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 666.995,
    height: 175.987,
    transform: "scale(1 -1)",
    fill: "url(#paint1_diamond_738_5236)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 666.995,
    height: 175.987,
    transform: "scale(-1 1)",
    fill: "url(#paint1_diamond_738_5236)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 666.995,
    height: 175.987,
    transform: "scale(-1)",
    fill: "url(#paint1_diamond_738_5236)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M676.451 381.203L718.723 405.609V454.42L676.451 478.825L634.18 454.42V405.609L676.451 381.203Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.39607843756675720,\"g\":0.35294118523597717,\"b\":0.85490196943283081,\"a\":1.0},\"position\":0.25961539149284363},{\"color\":{\"r\":1.0,\"g\":0.89019608497619629,\"b\":0.63921570777893066,\"a\":0.80000001192092896},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.39607843756675720,\"g\":0.35294118523597717,\"b\":0.85490196943283081,\"a\":1.0},\"position\":0.25961539149284363},{\"color\":{\"r\":1.0,\"g\":0.89019608497619629,\"b\":0.63921570777893066,\"a\":0.80000001192092896},\"position\":1.0}],\"transform\":{\"m00\":5.0388684030622244e-05,\"m01\":-494.03274536132812,\"m02\":923.46771240234375,\"m10\":296.32098388671875,\"m11\":8.4009116108063608e-05,\"m12\":233.04260253906250},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_738_5236_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676 381L718 405.25V453.75L676 478L634 453.75V405.25L676 381Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_diamond_738_5236_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.451 381.203L718.723 405.609V454.42L676.451 478.825L634.18 454.42V405.609L676.451 381.203Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_738_5236",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259615,
    stopColor: "#655ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE3A3",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_diamond_738_5236",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259615,
    stopColor: "#655ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE3A3",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBRightDark);
export default __webpack_public_path__ + "static/media/b_right_dark.29f10b26ea38dd5ef866b83521ecb5e2.svg";
export { ForwardRef as ReactComponent };